module.exports = __webpack_public_path__ + "img/slide-6-2.652bbbb8.jpg";